<admin-app-header></admin-app-header>

<div class="container-fluid">
    <div class="row header">
        <div class="col-12">
            <h2 class="mb-3">Admin Functions</h2>
            <p class="text-muted">Administrative utilities and one-time migration functions</p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">Data Synchronization</h5>
                </div>
                <div class="card-body">
                    <div class="mb-4">
                        <h6>Sync Email Data</h6>
                        <p class="text-muted small mb-2">
                            Updates email addresses and authentication data from Firebase Auth to the Admin Clients table.
                            <strong>Note:</strong> This is a one-time migration function. New auth changes are now synced automatically via listeners.
                        </p>
                        <button (click)="syncEmailData()" [disabled]="isSyncing" class="btn btn-success btn-sm text-white px-3 py-1">
                            <i *ngIf="!isSyncing" class="fas fa-sync"></i>
                            <span *ngIf="isSyncing" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            {{ isSyncing ? 'Syncing...' : 'Sync Email Data' }}
                        </button>
                    </div>

                    <div class="mb-4">
                        <h6>Sync Subscription Data</h6>
                        <p class="text-muted small mb-2">Updates subscription information for all clients in the Admin Clients table.</p>
                        <button (click)="syncSubscriptionData()" [disabled]="isSyncingSubscriptions" class="btn btn-primary btn-sm text-white px-3 py-1">
                            <i *ngIf="!isSyncingSubscriptions" class="fas fa-sync"></i>
                            <span *ngIf="isSyncingSubscriptions" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            {{ isSyncingSubscriptions ? 'Syncing...' : 'Sync Subscriptions' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">Review Requests</h5>
                </div>
                <div class="card-body">
                    <div class="mb-4">
                        <h6>1. Migration: Mark Old Subscriptions</h6>
                        <p class="text-muted small mb-2">
                            Marks all subscriptions older than 10 days as "review requested" to prevent sending review requests to old subscriptions.
                            <br />
                            <strong>Run this first</strong> before sending review requests to avoid messaging old clients.
                        </p>
                        <button (click)="migrateReviewRequested()" [disabled]="isMigratingReviewRequested" class="btn btn-secondary btn-sm px-3 py-1">
                            <i *ngIf="!isMigratingReviewRequested" class="fas fa-database"></i>
                            <span *ngIf="isMigratingReviewRequested" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            {{ isMigratingReviewRequested ? 'Migrating...' : 'Run Migration' }}
                        </button>
                    </div>

                    <hr />

                    <div class="mb-4">
                        <h6>2. Send Review Requests</h6>
                        <p class="text-muted small mb-2">
                            Sends WhatsApp review requests to clients with active subscriptions that are more than 4 hours old and haven't received a review request yet.
                        </p>
                        <button (click)="sendReviewRequests()" [disabled]="isSendingReviewRequests" class="btn btn-warning btn-sm px-3 py-1">
                            <i *ngIf="!isSendingReviewRequests" class="fas fa-star"></i>
                            <span *ngIf="isSendingReviewRequests" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            {{ isSendingReviewRequests ? 'Sending...' : 'Send Review Requests' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">CRM Data Cleanup</h5>
                </div>
                <div class="card-body">
                    <div class="mb-4">
                        <h6>Reset Incorrectly Converted Leads</h6>
                        <p class="text-muted small mb-2">
                            Finds all CRM leads marked as "Converted" who have never had an active or completed subscription. These leads will be reset to "New" status.
                            <br />
                            <strong>Use this to clean up leads that were incorrectly marked as converted.</strong>
                        </p>
                        <button (click)="resetIncorrectlyConvertedLeads()" [disabled]="isResettingIncorrectConverted" class="btn btn-outline-danger btn-sm px-3 py-1">
                            <i *ngIf="!isResettingIncorrectConverted" class="fas fa-broom"></i>
                            <span *ngIf="isResettingIncorrectConverted" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            {{ isResettingIncorrectConverted ? 'Processing...' : 'Reset Incorrect Leads' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">Information</h5>
                </div>
                <div class="card-body">
                    <div class="alert alert-info mb-0">
                        <i class="fas fa-info-circle me-2"></i>
                        <strong>Automatic Sync Enabled:</strong> Email and phone data is now automatically synced when users create accounts or update their information. These manual sync functions
                        are provided for one-time migrations or troubleshooting purposes only.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
